import { ChartProps } from '../props/shape/chart/chart-props';
import { ChartStore } from '../store/chart-store';
import { ChartMutationAPI } from '../api/chart-mutation-api';
import { ChartContext } from '../context/chart-context';
import { ChartBaseProps } from '../props/shape/chart/chart-base-props';
import { GraphicFrameBaseDataModel } from './graphic-frame-base-data-model';
import type { IEventManager } from '../manager/event-manager';
import type { PageContext } from '../context/page-context';
import type { GroupShapeDataModel } from './group-shape-data-model';
import type { IChartData } from '../data';
import type { RestrictedDataModel } from './data-model';
import type { IChartSpaceProps, IChartObjectProps, IChartProps } from '../props/shape/chart/chart-props';

export class ChartDataModel extends GraphicFrameBaseDataModel<IChartData> {
    public store: ChartStore;
    public props: IChartProps;
    public api: ChartMutationAPI;

    public context: ChartContext;

    public constructor(
        data: IChartData,
        events: IEventManager,
        pageContext: PageContext,
        public parent: GroupShapeDataModel,
    ) {
        super(data, events, pageContext, parent);

        this.context = new ChartContext(pageContext);
        this.context.setChart(this);

        this.store = new ChartStore(data, events, this);
        this.props = new ChartProps(this.store.data, this.context);
        this.api = new ChartMutationAPI(this, events);
    }

    /**
     * Chart因为属性太多，如果和其他元素props一样做全量声明成本太大，过于冗余。
     * 所以Chart内部在Props之上封了一层Proxy来减少属性声明
     * 因为需要针对Chart的getInheritedData做特殊处理
     */
    public getInheritedData(): IChartProps {
        return ChartBaseProps.getInheritedData(this.getBaseProps()) as IChartProps;
    }

    public getSubChart(index: number) {
        return this.store.subChartList[index];
    }

    /**
     * 获取此 shape 在母版版式上相关联的 shapeModel（占位符）
     */
    public getRelatedPlaceholder() {
        return this.context.getPlaceholder(this.props.nvPr?.ph);
    }
}

export { IChartProps, IChartSpaceProps, IChartObjectProps };
export type IChartDataModel = RestrictedDataModel<ChartDataModel>;
